import { safeGet } from './objectUtils';
import { getRegionFromUri } from './regionUtils';
export const paramsToObject = (entries: any) => {
  const result: any = {};
  for (const [key, value] of entries) {
    // each 'entry' is a [key, value] tupple
    result[key] = value;
  }
  return result;
};

export const isPageSecure = () => {
  let url = window.location.href;
  return isLinkSecure(url);
};

export const isLinkSecure = (href: string) => {
  return href?.split('/')?.includes('secure');
};

export const getQueryParams = () => {
  const urlParams = new URLSearchParams(safeGet(window, 'location.search', ''));
  let urlParamsObj = {} as any;
  urlParamsObj = paramsToObject(urlParams);
  return urlParamsObj;
};

// Can be used to read info from url
export const getProductSKUFromUrl = () => {
  return getQueryParams()['sku'];
};

export const getProductIdFromUrl = () => {
  return getQueryParams()['id'];
};

export const getVariantIDFromUrl = () => {
  return getQueryParams()['variantId'];
};

export const getCartIDFromUrl = () => {
  return getQueryParams()['cartId'];
};

export const getURLSegments = (): [string, string][] => {
  const result: Record<string, any> = {};
  const temp = location?.pathname?.split('/');
  let currentURL = '';

  for (let idx = 2; idx < temp?.length; idx++) {
    currentURL = `${currentURL}/${temp[idx]}`;
    result[`${temp[idx][0]?.toUpperCase()}${temp[idx]?.substring(1, temp[idx]?.length)}`] =
      currentURL;
  }

  return Object.entries(result);
};

export const getURIAsString = (): string => {
  const temp = location?.pathname?.split('/');
  let currentURL = '';

  for (let idx = 2; idx < temp?.length; idx++) {
    currentURL = `${currentURL}/${temp[idx]}`;
  }

  return currentURL;
};

export const getQueryStringObject = (url: string) => {
  const str1 = url.split('?')[1];
  const params: any = {};
  if (str1) {
    const pairs = str1.split('&');
    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      params[key] = decodeURIComponent(value.replace(/\+/g, ' '));
    }
  }
  return params;
};
export const buildAnalyticClickUrlCode = (url: string = '', clickCode?: string) => {
  if (clickCode && clickCode !== '') {
    return clickCode;
  }
  const tempUrl = url.split('/');
  if (tempUrl.length > 2) {
    return tempUrl.slice(2).join(':');
  } else {
    return 'home';
  }
};
export const detectBrowser = () => {
  if (navigator.userAgent.indexOf('Edge') > -1) {
    return 'Edge';
  } else if (
    navigator.userAgent.indexOf('Opera') !== -1 ||
    navigator.userAgent.indexOf('OPR') !== -1
  ) {
    return 'Opera';
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    return 'Chrome';
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    return 'Safari';
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    return 'Firefox';
  } else if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.DOCUMENT_NODE === true) {
    //IF IE > 10
    return 'IE';
  } else {
    return 'unknown';
  }
};
export const checkActiveUrl = (href: any, relativepath: any) => {
  const homeUrl = '/' + getRegionFromUri() + '/secure/home';
  if (relativepath === homeUrl) {
    relativepath = '/' + getRegionFromUri();
  }

  const urlPath = '/' + getRegionFromUri() + (href === '/' ? '' : href);
  const rpath = relativepath;
  return urlPath === rpath;
};
